var database = {};
module['exports'] = database;
database.collation = require("./collation");
database.column = require("./column");
database.engine = require("./engine");
database.type = require("./type");


//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/en/database/index.js
// module id = 378
// module chunks = 0